// extracted by mini-css-extract-plugin
module.exports = {"rightColumn":"antd-pro-pages-admin-shipments-admin-shipment-view-style-rightColumn","contentWrapper":"antd-pro-pages-admin-shipments-admin-shipment-view-style-contentWrapper"};